import { cn } from "../../lib/utils";
import {
  useFloating,
  offset,
  flip,
  shift,
  useClick,
  useInteractions,
  useDismiss,
} from "@floating-ui/react";
import { useState } from "react";
import { KontrolIcon, getIcon, getIconFromString } from "./utils";

export { KontrolIcon } from "./utils";

const KontrolColors = [
  "#D3C37B",
  "#FF6445",
  "#A10205",
  "#90CE48",
  "#0FAE00",
  "#48CEBA",
  "#4863CE",
  "#9F48CE",
  "#CE48C1",
];

export const IconDropdown = ({
  icon,
  setIcon,
  color,
  setColor,
}: {
  icon: KontrolIcon;
  setIcon: (icon: KontrolIcon) => void;
  color: string;
  setColor: (color: string) => void;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { refs, floatingStyles, context } = useFloating({
    placement: "bottom-start",
    middleware: [offset(4), flip(), shift()],
    open: isOpen,
    onOpenChange: setIsOpen,
  });

  const click = useClick(context);
  const dismiss = useDismiss(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([
    click,
    dismiss,
  ]);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        ref={refs.setReference}
        className="cursor-pointer border border-border rounded-md p-2 w-[42px] h-[42px] flex items-center justify-center"
        style={{ backgroundColor: color }}
        {...getReferenceProps()}
      >
        {getIcon(icon)}
      </button>

      {isOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
          className="p-2 z-10 w-64 rounded-md bg-input border border-border shadow-lg"
        >
          <div className="flex gap-2 justify-between p-2">
            {KontrolColors.map((c) => (
              <div
                key={c}
                className={cn(
                  "w-4 h-4 rounded-full cursor-pointer hover:border-2"
                )}
                style={{ backgroundColor: c }}
                onClick={() => setColor(c)}
              />
            ))}
          </div>
          <div className="grid grid-cols-6 gap-2 ">
            {Object.values(KontrolIcon).map((icon) => (
              <button
                type="button"
                key={icon}
                onClick={() => {
                  setIcon(icon);
                  setIsOpen(false);
                }}
                className="p-2 rounded-md cursor-pointer hover:bg-secondary"
              >
                {getIcon(icon)}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export const Icon = ({
  icon,
  className,
}: {
  icon: string;
  className?: string;
}) => {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      {getIconFromString(icon)}
    </div>
  );
};
